// extracted by mini-css-extract-plugin
export default {"disclaimers":"disclaimers__RXi8T","disclaimer":"disclaimer__QhRWq","disclaimer-title":"disclaimer-title__bLAnO","disclaimer-number":"disclaimer-number__V_hXo"};